import React, { useEffect, useState } from 'react'
import Header from '../component/Header'
import Footer from '../component/Footer'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Container, Row, Col } from 'react-bootstrap'
import ThemeTable from '../component/ThemeTable'
import PurchaseService from '../services/Purchase'
import Loader from '../component/Loader'
import LeadService from '../services/Lead'

const LeadRegistrionListing = () => {
    const [isLeadListType, setIsLeadListType] = useState(true)
    const [loading, setLoading] = useState(true);
    const [isLeadList, setIsLeadList] = useState([]);
    useEffect(() => {
        const leadFetchData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const responseLeadList = await LeadService.getLeads(token);
                const filteredDataLeadList = (responseLeadList.data.map((item, index) => {
                    let serialNo = <div className="text-center">{index + 1}</div>
                    //Status Check
                    let statusElement;
                    if (item.status == 0) {
                        statusElement = <div className='text-center'><span className='pendingTxt'>Pending</span></div>;
                    } else if (item.status == 1) {
                        statusElement = <div className='text-center'><span className='approvedTxt'>Approved</span></div>;
                    } else if (item.status == 2) {
                        statusElement = <div className='text-center'><span className='rejectedTxt'>Rejected</span></div>;
                    }
                    //TimeStamp Update
                    const dateTime = new Date(item.created_at);
                    const formattedDateTime = dateTime.toLocaleString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        second: 'numeric',
                        hour12: true,
                    });
                    return {
                        'Serial No': serialNo,
                        'Lead No': item.lead_id,
                        'Project Name': item.project_name,
                        'Customer Type': item.customer_type,
                        'Created Date': formattedDateTime,
                        'Status': statusElement

                    }
                }))
                setIsLeadList(filteredDataLeadList);
                setLoading(false);
            }
            catch (e) {
                console.error("Error fetching lead list");
            }
        }
        leadFetchData()
    }, [])
    return (
        <>
            {loading && <Loader />}
           
            <BreadCrumbSecttion pageTitle="Lead Registration List" currentPageName="Lead Registration List" />
            <section className='padTop50'>
                <Container>
                    <Row>
                        <Col>
                            <ThemeTable data={isLeadList} />
                        </Col>
                    </Row>
                </Container>
            </section>
            
        </>
    )
}

export default LeadRegistrionListing